import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="bg-white rounded-2xl shadow-soft border border-accent-100 p-6">
      <h3 className="font-heading font-semibold text-lg text-accent-800 mb-4">
        Categories
      </h3>
      
      <div className="space-y-2">
        {categories?.map((category) => (
          <button
            key={category?.name}
            onClick={() => onCategoryChange?.(category?.name)}
            className={`w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all duration-200 group ${
              activeCategory === category?.name
                ? 'bg-primary text-white shadow-md'
                : 'hover:bg-accent-50 text-accent-700'
            }`}
          >
            <div className="flex items-center space-x-3">
              <Icon 
                name={category?.icon} 
                size={20} 
                className={`transition-colors ${
                  activeCategory === category?.name
                    ? 'text-white' :'text-accent-500 group-hover:text-accent-700'
                }`}
              />
              <span className="font-medium">{category?.name}</span>
            </div>
            <span className={`text-sm font-medium px-2 py-1 rounded-full ${
              activeCategory === category?.name
                ? 'bg-white/20 text-white' :'bg-accent-100 text-accent-600 group-hover:bg-accent-200'
            }`}>
              {category?.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;